export default "__VITE_ASSET__54093272__"